import { render, staticRenderFns } from "./DecisionForm.vue?vue&type=template&id=72c6b69c&scoped=true&"
import script from "./DecisionForm.vue?vue&type=script&lang=js&"
export * from "./DecisionForm.vue?vue&type=script&lang=js&"
import style0 from "./DecisionForm.vue?vue&type=style&index=0&id=72c6b69c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6b69c",
  null
  
)

export default component.exports